import { useEffect, useMemo, useState } from "react";
import Fuse from "fuse.js";

const HEROES_DATA_URL = "https://static.bigbrain.gg/deadlock/staticdata/gamedata/cleaned_all_heroes_v2.json";

export function useSearchBarPages(options = {}) {
  const [savedResults, setSavedResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function fetchHeroesData() {
      try {
        const response = await fetch(HEROES_DATA_URL);
        const data = await response.json();

        const formattedData = [
          {
            title: "Heroes",
            pages: data.map((hero) => {
              const formattedName = hero.DisplayName.toLowerCase()
                .replace(/\s*&\s*/g, "_and_") // Replace " & " (with spaces) with "_and_"
                .replace(/\s+/g, "_"); // Replace remaining spaces with underscores

              return {
                key: hero.DisplayName.toLowerCase(),
                displayName: hero.DisplayName,
                imgKey: hero.IconHeroCard.replace(
                  "file://{images}",
                  "https://static.bigbrain.gg/deadlock/staticdata/panorama/images",
                ).replace(".psd", "_psd.png"),
                url: `heroes/${formattedName}/build`,
              };
            }),
          },
        ];

        setSavedResults(formattedData);
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    }

    fetchHeroesData();
  }, []);

  return { data: savedResults, loading, error };
}

export function useBestSearchMatch() {
  const { data: searchPages } = useSearchBarPages();
  const fuseOpts = {
    shouldSort: true,
    includeScore: true,
    keys: ["key"],
  };

  return (query) => {
    if (searchPages && searchPages[0]?.pages) {
      const fuse = new Fuse(searchPages[0].pages, fuseOpts);
      return fuse.search(query.trim());
    }
    return [];
  };
}
